import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {AnalyticsLogo} from '../../logos/AnalyticsLogo';
import {FaIcon} from '../../FaIcon';
import {ChannelAccountSelect} from '../../selects/ChannelAccountSelect';
import {ANALYTICS_CHANNEL} from '../../channels/channels';
import '../../../sass/elements/_ga4-property-card.scss';

class GA4PropertyCardClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
        };
        this.startEditing = this.startEditing.bind(this);
        this.cancelEditing = this.cancelEditing.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    startEditing() {
        this.setState({isEditing: true});
    }

    cancelEditing() {
        this.setState({isEditing: false});
    }

    handleAccountChange(selectedAccountId, selectedAccountName) {
        this.setState({isEditing: false});
        if (this.props.onAccountChange) {
            this.props.onAccountChange(selectedAccountId, selectedAccountName);
        }
    }

    getSelectedAccountData() {
        if (!this.props.selectedAccount || !this.props.allAccounts) return null;
        return this.props.allAccounts.find(a => a.id === this.props.selectedAccount) || null;
    }

    hasSelectedAccount() {
        return this.getSelectedAccountData() !== null;
    }

    renderSelectMode() {
        const {t} = this.props;
        return (
            <div className="ga4-property-card-select-mode">
                <div className="ga4-property-card-select-mode-select">
                    <ChannelAccountSelect
                        channel={ANALYTICS_CHANNEL}
                        blackSelection={this.props.blackSelection !== undefined ? this.props.blackSelection : true}
                        selectedAccount={this.props.selectedAccount}
                        allAccounts={this.props.allAccounts}
                        onAccountChange={this.handleAccountChange}
                        canCreateNewAccount={false}
                        showFormValidationTexts={false}
                        addLinkToConnectOption={this.props.addLinkToConnectOption}
                    />
                </div>
                {this.hasSelectedAccount() && (
                    <button
                        type="button"
                        className="ga4-property-card-cancel"
                        onClick={this.cancelEditing}
                    >
                        {t('ga4_property.cancel')}
                    </button>
                )}
            </div>
        );
    }

    renderCard() {
        const account = this.getSelectedAccountData();
        const hasAccess = account.has_access !== false;
        const {t} = this.props;

        return (
            <div className={`ga4-property-card ${hasAccess ? '' : 'no-access'}`}>
                <div className="ga4-property-card-logo">
                    <AnalyticsLogo height={28} width={28} hspace={0} vspace={0} />
                </div>
                <div className="ga4-property-card-body">
                    <div className="ga4-property-card-name" title={account.name}>
                        {account.name}
                    </div>
                    <div className="ga4-property-card-meta">
                        <span className="ga4-property-card-label">
                            {t('ga4_property.ga4_label')}
                        </span>
                        <span className="ga4-property-card-dot">·</span>
                        <span className="ga4-property-card-id">ID {account.id}</span>
                        {!hasAccess && (
                            <span className="ga4-property-card-no-access">
                                {t('channel_account_select.no_connection')}
                            </span>
                        )}
                    </div>
                </div>
                <button
                    type="button"
                    className="ga4-property-card-action"
                    onClick={this.startEditing}
                    aria-label={t('ga4_property.change')}
                >
                    <FaIcon iconName="pen" />
                    <span>{t('ga4_property.change')}</span>
                </button>
            </div>
        );
    }

    render() {
        if (this.state.isEditing || !this.hasSelectedAccount()) {
            return this.renderSelectMode();
        }
        return this.renderCard();
    }
}

export const GA4PropertyCard = withTranslation()(GA4PropertyCardClass);
export default GA4PropertyCard;
